
jQuery.noConflict();
var is_ie_lt9 = false;
var is_ie_lt7 = false;
var is_mobile = false;
 

function getParameterByName( name ){
    var regexS = "[\\?&]"+name+"=([^&#]*)", 
  regex = new RegExp( regexS ),
  results = regex.exec( window.location.search );
  if( results == null ){
    return "";
  } else{
    return decodeURIComponent(results[1].replace(/\+/g, " "));
  }
}
//Calcul le nombre de jour entre 2 date
function countDays(date1, date2){
    var one_day=1000*60*60*24;
    return Math.ceil((date1.getTime()- date2.getTime()) /one_day);
}
function compareDates(dateStart,numberOfDays){
	  	var now = new Date();
		var dateDebut = jQuery.datepicker.formatDate("yy-mm-dd", now);
		now.setDate(now.getDate()+numberOfDays);
		var dateFin = jQuery.datepicker.formatDate("yy-mm-dd", now);
		var diff = new Date(dateFin - dateDebut);
		return countDays(new Date(dateStart) , new Date(dateFin));
}
(function($,sr){

  // debouncing function from John Hann
  // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
  var debounce = function (func, threshold, execAsap) {
      var timeout;

      return function debounced () {
          var obj = this, args = arguments;
          function delayed () {
              if (!execAsap)
                  func.apply(obj, args);
              timeout = null;
          };

          if (timeout)
              clearTimeout(timeout);
          else if (execAsap)
              func.apply(obj, args);

          timeout = setTimeout(delayed, threshold || 100);
      };
  }
  // smartresize 
  jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };

})(jQuery,'smartresize');

jQuery(window).smartresize(function(){
  var wh=jQuery(window).height();
  var ww=jQuery(window).width();

  if(ww<=1280){
    var wr=(ww*100)/1280;
  } else{
    wr=100;
  }
  var bs=wr*2.55;
  jQuery(".liquide").animate({"height":bs});
});


jQuery(document).ready(function(){

    var ww=jQuery(window).width();
    if(ww<=1280){
      var wr=(ww*100)/1280;
    } else {
      wr=100;
    }
    var bs=wr*2.55;
    jQuery(".liquide").animate({"height":bs});



    if(jQuery('#container_plan_site').css('display')=='none') {
        is_mobile = true;       
     }

  //Traitement Spécifique pour l'accueil de l'espacecollaboratif de la DRH
    if (jQuery('#COLLAB_COLLABDRH').length ) {
        var optionValue = jQuery("#COLLAB_COLLABDRH").val() ;
        var optionValueModifie = optionValue.replace("&ACTION=ACCUEIL&","&ACTION=CONSULTER_DOSSIERS&");
        jQuery('#COLLAB_COLLABDRH').attr("value", optionValueModifie);
    }
    
    

  /*RESIZE IMAGE VIGNETTE*/
  if (jQuery('.vignette').length ) {
    jQuery('.vignette').resizeToParent();
  }
  if (jQuery('body.article div.photo').length ) {
    jQuery('body.article div.photo img').resizeToParent();
  }
  if (jQuery('body.petiteannonce div.photo').length ) {
	    jQuery('body.petiteannonce div.photo img').resizeToParent();
  }

  if (jQuery('body.evenement div.photo').length ) {
    jQuery('body.evenement div.photo img').resizeToParent();
  }
  if (jQuery('body.annuaireksup div.photo').length ) {
	    jQuery('body.annuaireksup div.photo img').resizeToParent();
  }
  
  
 if (jQuery('ul#liste_resultats li .vignette_deco').length ) {
    jQuery('ul#liste_resultats li .vignette_deco img').resizeToParent();
  }

  //AUGMENTATION DE LA TAILLE DE LA VIGNETTE POUR LA GALLERIE
   if ( ( jQuery('#page .style1_media_vignette').length)  && (jQuery('.pageAccueilSite #complement .style1_media_vignette').length == 0)  )  {    
        jQuery("#page span.style1_media_vignette").removeAttr("style");

    }

   //Execution du lazy loading lors du changement de page de la galerie media
   jQuery(".pagination_droite.pagination_suivant a").click(function () {
       jQuery(".pagination_contenu img.lazy")
       .lazyload({
         event: "lazyload"
       })
       .trigger("lazyload");
   });
   
   
 //POPUP AGRANDISSEMENT AUTOMATIQUE DES IMAGES INSEREES DANS LE CORPS DES ACTU /ARTICLE / STRUCTURE / ASSO / EVENEMENT
   if ( jQuery('.actualite #description img').length ) { 
  	 jQuery(".actualite #description img").each(function(){ 
  		 if ( ( jQuery(this).parent().prop("tagName") != "A" ) && ( jQuery(this).parent().attr('class') != "style1_media_vignette" )  && ( jQuery(this).parent().parent().prop("tagName") != "A" )  ) { 
  		    jQuery(this).wrap( "<a href=\""+jQuery(this).attr('src')+"\" title=\""+jQuery(this).attr('alt')+"\" class=\"image-popup-no-margins\"></a>" );
  		 }
  	 });
   }

   if (jQuery('.article #description img').length ) { 
  	 jQuery(".article #description img").each(function(){ 
  		 if ( ( jQuery(this).parent().prop("tagName") != "A" ) && ( jQuery(this).parent().attr('class') != "style1_media_vignette" )  && ( jQuery(this).parent().parent().prop("tagName") != "A" )  ) { 
  	  	     jQuery(this).wrap( "<a href=\""+jQuery(this).attr('src')+"\" title=\""+jQuery(this).attr('alt')+"\" class=\"image-popup-no-margins\"></a>" );
  		 }
  	 });
   }
   if (jQuery('.evenement #description img').length ) { 
	  	 jQuery(".evenement #description img").each(function(){ 
	  		 if ( ( jQuery(this).parent().prop("tagName") != "A" ) && ( jQuery(this).parent().attr('class') != "style1_media_vignette" ) && ( jQuery(this).parent().parent().prop("tagName") != "A" )  ) { 
	  	  	     jQuery(this).wrap( "<a href=\""+jQuery(this).attr('src')+"\" title=\""+jQuery(this).attr('alt')+"\" class=\"image-popup-no-margins\"></a>" );
	  		 }
	  	 });
	   }
   if (jQuery('.defaultstructureksup .motif img').length ) { 
  	 jQuery(".defaultstructureksup .motif img").each(function(){ 
  		 if ( ( jQuery(this).parent().prop("tagName") != "A" ) && ( jQuery(this).parent().attr('class') != "style1_media_vignette" )  && ( jQuery(this).parent().parent().prop("tagName") != "A" )  ) { 
  			 jQuery(this).wrap( "<a href=\""+jQuery(this).attr('src')+"\" title=\""+jQuery(this).attr('alt')+"\" class=\"image-popup-no-margins\"></a>" );
  		 }
  	 });
   }
   if (jQuery('.associationetudiant .element_deco img').length ) { 
  	 jQuery(".associationetudiant .element_deco img").each(function(){ 
  		 if ( ( jQuery(this).parent().prop("tagName") != "A" ) && ( jQuery(this).parent().attr('class') != "style1_media_vignette" )  && ( jQuery(this).parent().parent().prop("tagName") != "A" )  ) { 
  			 jQuery(this).wrap( "<a href=\""+jQuery(this).attr('src')+"\" title=\""+jQuery(this).attr('alt')+"\" class=\"image-popup-no-margins\"></a>" );
  		 }
  	 });
   }


//MENU PRINCIPAL
 jQuery('#cssmenu > ul > li.mobile > a').on('click touchstart', function(e) { 
     e.preventDefault();
	 jQuery('#cssmenu').toggleClass('expand');
  });
 


  //FERMETURE DU MENU LORS DU CLICK EN DEHORS
  jQuery(document).bind('click', function(e) {
    var jQueryclicked = jQuery(e.target);

    if (! jQueryclicked.parents().parents().parents().hasClass("expand")) {
        jQuery('div#cssmenu.expand').removeClass('expand');
      }
  });






//FLEXSLIDER
  if  (is_ie_lt9==true){
    containerFlexSlider = ".flexslider";
  } else {
    containerFlexSlider = ".numSlide";
  }

  jQuery('.flexslider').flexslider({
    animation:'fade',
    //direction:'vertical',
    //controlNav:'thumbnails',
    controlsContainer:  containerFlexSlider,
    controlNav: false,
    slideshow:true,
    slideshowSpeed:7000,
    animationSpeed:700,
    useCSS:true,
    smoothHeight:true,
    pauseOnHover:true,
    mousewheel:false,
    multipleKeyboard:true,
    prevText: " << Pr&eacute;c&eacute;dent",           //String: Set the text for the "previous" directionNav item
    nextText: "Suivant >>",               //String: Set the text for the "next" directionNav item
    pausePlay: false,               //Boolean: Create pause/play dynamic element
    pauseText: 'Pause',             //String: Set the text for the "pause" pausePlay item
    playText: 'Jouer',
    start: function(slider) {
 
    	jQuery.flexloader(slider, {
            'background_images': true,
            'class_name': 'flexloader-custom-class-background-image-loaded'
          });
     jQuery('.currentSlide').text(slider.currentSlide+1);
     jQuery('.totalSlides').text(slider.count);
    },
    after: function(slider) {

    	jQuery.flexloader(slider, {
            'background_images': true,
            'class_name': 'flexloader-custom-class-background-image-loaded'
        });
        jQuery('.currentSlide').text(slider.currentSlide+1);
      }
  });
  if (is_mobile){
    jQuery(".flex-container .flexslider .slides li").css("background-image","");
    jQuery(".visuel-rubrique").css("background-image","none");

  }

  //TRAITEMENT DU BACKGROUND 100% 
  jQuery(".slides li").css( "background-size", "cover" );
  jQuery("div.visuel-rubrique").css({backgroundSize: "cover"});



  /*MAGNIFIQUE POPUP*/
  if (jQuery('.image-popup-no-margins').length ) {
    jQuery('.image-popup-no-margins').magnificPopup({ 
      type: 'image',
      mainClass: 'mfp-with-zoom', // this class is for CSS animation below

      zoom: {
        enabled: false, // By default it's false, so don't forget to enable it

        duration: 300, // duration of the effect, in milliseconds
        easing: 'ease-in-out', // CSS transition easing function 

        // The "opener" function should return the element from which popup will be zoomed in
        // and to which popup will be scaled down
        // By defailt it looks for an image tag:
        opener: function(openerElement) {
          // openerElement is the element on which popup was initialized, in this case its <a> tag
          // you don't need to add "opener" option if this code matches your needs, it's defailt one.
          return openerElement.is('img') ? openerElement : openerElement.find('img');
        }
      }

    });
  }





  if (jQuery('.recherche form#recherche_avancee #TYPE_DOCUMENT option').length ) {
  jQuery('.recherche form#recherche_avancee #TYPE_DOCUMENT option').each(function() { 
	     var myOption = jQuery(this).text();
	     var myPos= myOption.indexOf("{");
	    if ( myPos >= 0 ) {
	      jQuery(this).remove();
	    }
	   });
  }
  
  if (jQuery('.recherche form#recherche_avancee #THEMATIQUE option').length ) {
	  jQuery('.recherche form#recherche_avancee #THEMATIQUE option').each(function() { 
		  var myOption = jQuery(this).text();
		  //ON SUPPRIMER TOUTES LES THEMATIQUES ENTRE ACCOLADES ET DIFFERENTS DE INTRANET
		  var myPosBU= myOption.indexOf("{BU");
		  var myPosBUI= myOption.indexOf("{BU Intranet");
		  var myPosProjets= myOption.indexOf("{Projets");
		  if ( myPosBU >= 0 || myPosBUI >= 0 || myPosProjets >= 0 ) {
			  jQuery(this).remove();
		  }
		  //ON SUPPRIMES LES ACCOLADES DES THEMATIQUES RESTANTES
		  var myPos= myOption.indexOf("{");
		  var myPos2= myOption.indexOf("}");
		  var myLen = myPos2 - myPos;
		  if ( myPos >= 0 && myPos2 >= 0 ) {
			  jQuery(this).text(myOption.substring(myLen+1));
		  }
	   });
  }
  
  if (jQuery('.extension-agenda__requeteur #THEMATIQUE option').length ) {
	  jQuery('.extension-agenda__requeteur #THEMATIQUE option').each(function() { 
		     var myOption = jQuery(this).text();
		     var myPos= myOption.indexOf("{");
		    if ( myPos >= 0 ) {
		      jQuery(this).remove();
		    }
		   });
  }
  
  if (jQuery('#typeActu option').length ) {  
	  jQuery('#typeActu option').each(function() { 
		     var myOption = jQuery(this).text();
		     var myPos= myOption.indexOf("{");
		     var myPos2= myOption.indexOf("}");
		     var myLen = myPos2 - myPos;
		    if ( myPos >= 0 && myPos2 >= 0 ) {
		    	jQuery(this).text(myOption.substring(myLen+1));
		    }
		   });	
  } 
	 
  if (jQuery('#thematiqueFocus option').length ) {  
	  jQuery('#thematiqueFocus option').each(function() { 
		  var myOption = jQuery(this).text();
		  var myPos= myOption.indexOf("{");
		  var myPos2= myOption.indexOf("}");
		  var myLen = myPos2 - myPos;
		  if ( myPos >= 0 && myPos2 >= 0 ) {
			  jQuery(this).text(myOption.substring(myLen+1));
		  }
	  });	
  }

  //SUPPRESSION DES LIBELLES DIFFERENT DE "INTRANET" SUR FORMULAIRE SAISIE FRONT POUR LES THEMATIQUES
  if (jQuery('#form_saisie_front #kmultiselectTHEMATIQUE .k-multiselect-parent .kscrollable li').length ) {
	  jQuery('#form_saisie_front #kmultiselectTHEMATIQUE .k-multiselect-parent .kscrollable li').each(function() { 
		     var myOption = jQuery(this).attr("title");
		     var myPos1= myOption.indexOf("{");
		     var myPos2= myOption.indexOf("{Intranet}");
		    if ( myPos1 >= 0 && myPos2 == -1 ) {
		      jQuery(this).remove();
		    }
	   });
  }
  //SUPPRESSION DES LIBELLES DIFFERENT DE "INTRANET" SUR FORMULAIRE SAISIE FRONT POUR LES THEMATIQUES D'EVENEMENT
  if (jQuery('#form_saisie_front #kmultiselectAGENDAEVT_THEMATIQUE .k-multiselect-parent .kscrollable li').length ) {
	  jQuery('#form_saisie_front #kmultiselectAGENDAEVT_THEMATIQUE .k-multiselect-parent .kscrollable li').each(function() { 
		     var myOption = jQuery(this).attr("title");
		     var myPos1= myOption.indexOf("{");
		     var myPos2= myOption.indexOf("{Intranet}");
		    if ( myPos1 >= 0 && myPos2 == -1 ) {
		      jQuery(this).remove();
		    }
	   });
  }
  
  
  
  //SUPPRESSION DES LIBELLES DIFFERENT DE "INTRANET" SUR FORMULAIRE SAISIE FRONT POUR LES TYPES DE DOCUMENT
  if (jQuery('#form_saisie_front #TYPE_DOCUMENT option').length ) {
	  jQuery('#form_saisie_front #TYPE_DOCUMENT option').each(function() { 
		    var myOption = jQuery(this).text();
		     var myPos1= myOption.indexOf("{");
		     var myPos2= myOption.indexOf("{Intranet}");
		    if ( myPos1 >= 0 && myPos2 == -1 ) {
		      jQuery(this).remove();
		    }
		  });
  	}

  //SUPPRESSION DES LIBELLES ENTRE {} SUR LES FICHES ANNUAIRE POUR LES DISCIPLINE
  if (jQuery('.annuaireksup .discipline .motif__contenu').length ) {
	  jQuery('.annuaireksup .discipline .motif__contenu').each(function() { 
		    var myOption = jQuery(this).text();
		    var myPos= myOption.indexOf("{");
		    var myPos2= myOption.indexOf("}");
		    if ( myPos >= 0 && myPos2 >= 0 ) {
		    	jQuery(this).text(jQuery(this).text().replace( /{\/?[\w]+}/g, ''));
		    }
	   });
  }

  
  

  //PAPAPARSE O2F
  if (jQuery('#odf_fst_all').length ) {
	  var content = Papa.parse(jQuery("#odf_fst_all")[0].innerHTML, papa_config);
	  jQuery("#odf_fst_all").html(render_odf(content, "Toutes les formations", ["COMPOSANTE"], render_composante, ["DIPLOME", , "MEN_ID", "MEN_TITLE"], render_diplome, render_parcours));
  }

  //Deplacement Carte Gmap ou OpenStretMap au dessus du plan du site puis chargement de la carte OpenStreeMap si présente
  if (jQuery('.pagelibre #container_maps').length ) {
	  jQuery(".pagelibre #container_maps").insertBefore( "#container-plan-site");
	  jQuery(".pagelibre #container-container-plan-site").css("margin-top","0");
	  jQuery(".pagelibre #container_maps").toggle();
  }

  if (jQuery('#omap').length ) {
		map = new OpenLayers.Map("omap");
		map.addLayer(new OpenLayers.Layer.OSM());
		var lonLat = new OpenLayers.LonLat( jQuery("#LongitudeOL").val() , jQuery("#LatitudeOL").val() )
		.transform(
			 new OpenLayers.Projection("EPSG:4326"), // transform from WGS 1984
		     map.getProjectionObject() // to Spherical Mercator Projection
		);
		var zoom=jQuery("#ZoomOL").val();
		if (zoom.length === 0) {
			zoom = 17;
		}
	    var markers = new OpenLayers.Layer.Markers( "Markers" );
	    map.addLayer(markers);
	    markers.addMarker(new OpenLayers.Marker(lonLat));
	    map.setCenter (lonLat, zoom);
  }

});


jQuery(window).load(function(){
  jQuery("img.lazy").lazyload({
      effect: "fadeIn",
      failure_limit : 7
  });

 
if(jQuery('#container_plan_site').css('display')=='none') {
      is_mobile = true;       
  }

//TRAITEMENT DATE AGENDA SUR PAGE D'ACCEUIL
  jQuery("ul.evenements li div").each(function(){ 
    
    var nbrEnfant = jQuery(this).children().length;
    if (nbrEnfant>1){
      var jourDateDebut = jQuery(this).children().eq(0).children().eq(0).text();
      var jourDateFin = jQuery(this).children().eq(1).children().eq(0).text();
      jQuery(this).children().eq(1).remove();
      var periode = jourDateDebut + "/" + jourDateFin;
      //AFFECTION DU JOUR DE FIN DANS LE BLOC JOUR DE DEBUT
      jQuery(this).children().eq(0).children().eq(0).text(periode);
      //RECUPERATION DE NOUVEAU CONTENU DATE DE DEBUT + DATE DE FIN AVEC SUPPRESSION DU "-" EN FIN DE BLOC
     // var nouvellePeriode = jQuery(this).html().replace("-", "");
      var nouvellePeriode = jQuery(this).html().substr(0,jQuery(this).html().length-1); 
      //AFFECTATION DU NOUVEAU CONTENU 
      jQuery(this).html(nouvellePeriode);
    }
  });


  //SCROLL TO TOP
  jQuery(window).scroll(function(){
    if (jQuery(this).scrollTop() > 100) {
      jQuery('.scrollup').fadeIn();
    } else {
      jQuery('.scrollup').fadeOut();
    }
  }); 

  jQuery('.scrollup').click(function(){
    jQuery("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });


  //MENU LANGUE
  jQuery("#menu_langues .dropdown dt a").click(function() {
    jQuery("#menu_langues .dropdown dd ul").toggle();
  });
                        
  jQuery("#menu_langues .dropdown dd ul li a").click(function() {
    var text = jQuery(this).html();
    jQuery("#menu_langues .dropdown dt a span").html(text);
    jQuery("#menu_langues .dropdown dd ul").hide();
  });
                        
  jQuery(document).bind('click', function(e) {
    var jQueryclicked = jQuery(e.target);
    if (! jQueryclicked.parents().hasClass("dropdown"))
      jQuery("#menu_langues .dropdown dd ul").hide();
   });


  
  //PAGE ACTU, FILTRAGE LISTE DE TYPE D'ACTU
  //////////////////////////////////////////

  jQuery("#typeActu option").each(function(){ 
    var libelleOption = jQuery(this).text();
    var valeurOption = jQuery(this).val();
    var nbreOccurence = jQuery(".avec_vignette_ajax."+ valeurOption).length; 
    if (valeurOption != "ALL"){
      if (nbreOccurence == 0 ){
       // alert(libelleOption + " " +valeurOption + " " +nbreOccurence)
        jQuery(this).remove();
      } else {
        jQuery(this).text(libelleOption + " ("+nbreOccurence+ ")");  
      }
    }
   // jQuery(this).attr('src','/jspWWW/scripts/lazyload/load.jpg');
  });


  //Filtrage des actu via le type
  jQuery("#typeActu").change(function() {
    var valeur= jQuery(this).val();
    var aMasquer = jQuery(".avec_vignette_ajax");
    var aAfficher = jQuery("."+ valeur);
    jQuery("#resetFiltre").fadeOut( "fast" ); 
    if (valeur== "ALL"){
     aMasquer.fadeIn( "slow" ); 
    } else {
      aMasquer.fadeOut( "fast" ); 
      aAfficher.fadeIn( "slow" ); 
    }
    jQuery(".vignette_deco img.lazy")
    .lazyload({
      event: "lazyload",
      effect: "fadeIn"
    })
    .trigger("lazyload");
  });

  //CLICK SUR TYPE ACTU
  if ( is_mobile == false ){
    jQuery(".avec_vignette_ajax .type_vignette_deco").click(function () {
      jQuery(".vignette_deco img.lazy")
      .lazyload({
        event: "lazyload",
        effect: "fadeIn"
      })
      .trigger("lazyload");
      var classeaAfficher = jQuery(this).attr('class');
      var classes = jQuery(this).attr('class');

      jQuery("#resetFiltre").fadeIn( "slow" ); 
      jQuery(".avec_vignette_ajax .type_vignette_deco").each(function(){ 
        if (jQuery(this).hasClass(classes)) {
          jQuery(this).parent().fadeIn( "slow" ); 
        } 
      });
    });
  }

 //RESET FILTRE TYPE ACTU
 jQuery("#resetFiltre").click(function () {
   jQuery(".avec_vignette_ajax").fadeIn( "slow" ); 
   jQuery("#resetFiltre").fadeOut( "fast" ); 
   jQuery('#typeActu').prop('selectedIndex',0);
 });
 //////////////////////////////////////////




  //PAGE FOCUS, FILTRAGE LISTE DE THEMATIQUE
  //////////////////////////////////////////
  jQuery("#thematiqueFocus option").each(function(){ 
    var libelleOption = jQuery(this).text();
    var valeurOption = jQuery(this).val();
    var nbreOccurence = jQuery(".avec_vignette_ajax."+ valeurOption).length; 
    if (valeurOption != "TOUS"){
      if (nbreOccurence == 0 ){
       // alert(libelleOption + " " +valeurOption + " " +nbreOccurence)
        jQuery(this).remove();
      } else {
        jQuery(this).text(libelleOption + " ("+nbreOccurence+ ")");  
      }
    }
  });
//Filtrage des actu via le type
  jQuery("#thematiqueFocus").change(function() {
    var valeur= jQuery(this).val();
    var aMasquer = jQuery(".avec_vignette_ajax");
    var aAfficher = jQuery("."+ valeur);
    jQuery("#resetFiltre").fadeOut( "fast" ); 
    if (valeur== "TOUS"){
     aMasquer.fadeIn( "slow" ); 
    } else {
      aMasquer.fadeOut( "fast" ); 
      aAfficher.fadeIn( "slow" ); 
    }
    jQuery(".vignette_deco img.lazy")
    .lazyload({
      event: "lazyload",
      effect: "fadeIn"
    })
    .trigger("lazyload");
  });

  //CLICK SUR THEMATIQUE FOCUS
  if ( is_mobile == false ){
    jQuery(".avec_vignette_ajax .type_vignette_deco").click(function () {
      jQuery(".vignette_deco img.lazy")
      .lazyload({
        event: "lazyload",
        effect: "fadeIn"
      })
      .trigger("lazyload");
      var classeaAfficher = jQuery(this).attr('class');
      var classes = jQuery(this).attr('class');
      jQuery(".avec_vignette_ajax").fadeOut( "fast" ); 
      jQuery("#resetFiltre").fadeIn( "slow" ); 
      jQuery(".avec_vignette_ajax .type_vignette_deco").each(function(){ 
        if (jQuery(this).hasClass(classes)) {
          jQuery(this).parent().fadeIn( "slow" ); 
        } 
      });
    });
  }

 //RESET FILTRE TYPE ACTU
 jQuery("#resetFiltre").click(function () {
   jQuery(".avec_vignette_ajax").fadeIn( "slow" ); 
   jQuery("#resetFiltre").fadeOut( "fast" ); 
   jQuery('#thematiqueFocus').prop('selectedIndex',0);
 });
  //////////////////////////////////////////

 jQuery(".avec_vignette_ajax .voirPlus").each(function(){ 
    var curHeight = jQuery(this).prev().height();
    var curRealHeight = jQuery(this).prev().css("height", "auto").height();
    jQuery(this).prev().css("height", curHeight);
    if ( curHeight >= curRealHeight) {
      jQuery(this).prev().css("height", curHeight+30);
      jQuery(this).css("display", "none");
      jQuery(this).parent().children().first().css("display", "none");
    }
  });


    //RECHERCHE ANNUAIRE AUTOCOMPLETE
    jQuery(function() {
      function highlightText(text, jQuerynode) {
        var searchText = jQuery.trim(text).toLowerCase(), currentNode = jQuerynode.get(0).firstChild, matchIndex, newTextNode, newSpanNode;
        while ((matchIndex = currentNode.data.toLowerCase().indexOf(searchText)) >= 0) {
          newTextNode = currentNode.splitText(matchIndex);
          currentNode = newTextNode.splitText(searchText.length);
          newSpanNode = document.createElement("span");
          newSpanNode.className = "highlight";
          currentNode.parentNode.insertBefore(newSpanNode, currentNode);
          newSpanNode.appendChild(newTextNode);
        }
      }
       
      if (jQuery('.recherche #NOM').length ) {
        jQuery("#NOM").autocomplete({
          source: "/ajax/annuaire/",
          minLength: 3
        }).data("ui-autocomplete")._renderItem = function(ul, item) {
          var jQuerya = jQuery("<a></a>").text(item.label);
          highlightText(this.term, jQuerya);
          return jQuery("<li></li>").append(jQuerya).appendTo(ul);
        };
      };
    });

  jQuery("#cloud-keywords button").each(function(){ 
    var objet = "";
    var kw = "";
    var rh = "";
    var ln = "";
    var rs = "";
    var allClasses = "";
    var url = "/search?beanKey=";
    
    jQuery(this).click(function() {
      objet = jQuery(this).attr('class').split(' ')[0];
      rh = jQuery(this).attr('class').split(' ')[1];
      ln = jQuery(this).attr('class').split(' ')[2];
      rs = jQuery(this).attr('class').split(' ')[3];
      allClasses = jQuery(this).attr('class').split(" ").length - 1;

      if ( allClasses > 4 ){
        for (var i = 4; i<=allClasses; i++) {
          kw = kw + " " + jQuery(this).attr('class').split(' ')[i];

        }
      } else {
          kw = jQuery(this).attr('class').split(' ')[4];
      }

      //alert("&RH="+rh+"&LANGUE="+ln+"&CODE_RUBRIQUE="+rs+"&QUERY="+kw);
      window.location.href = url + "&RH="+rh+"&l="+ln+"&q="+kw;
      return false;
    });
  });


  //RECLASSEMENT ALPHABETIQUE DES FICHIERS JOINTS DES FICHES DOCUMENTS
  if (jQuery('.document .fichiers-joints li.fichiers-joints__item').length && $(".document .fichiers-joints li.fichiers-joints__item").length > '1' &&  moment( jQuery( "meta[name='Date-Revision-yyyymmdd']" ).attr("content").slice(0, 8 ) ).isBefore('20220718') ) {
	  jQuery('ul.fichiers-joints').fadeOut( 0 ); 
	  tinysort('.document .fichiers-joints li.fichiers-joints__item');
	  jQuery('ul.fichiers-joints').fadeIn( "slow" ); 
  }

  //RECLASSEMENT ALPHABETIQUE TEMPORAIRE POUR LES DATES DU PLUGIN AGENDA DANS LES FICHES COURS
  if (jQuery('.cours .dates-sessions li.session__item').length && $(".cours .dates-sessions li.session__item").length > '1' ) {
	  jQuery('ul.dates-sessions').fadeOut( 0 ); 
	  tinysort('.cours .dates-sessions li.session__item');
	  jQuery('ul.dates-sessions').fadeIn( "slow" ); 
  }
  
  
  //MOTEUR DE RECHERCHE INTREGRE SOUS FORME D'INCLUDE HTML DANS LES ZONES DE CONTENUS
  if (jQuery('#recherche_include').length ) {
	jQuery('#recherche_include input[name=CODE_RUBRIQUE]').val(jQuery('#recherche_simple input[name=CODE_RUBRIQUE]').val());;
	jQuery('#recherche_include input[name=RH]').val(jQuery('#recherche_simple input[name=RH]').val());;
  }

  //OWN CAROUSEL
  jQuery(function () {
	  jQuery('.owl-carousel').each(function () {
	      let jQueryt = jQuery(this);
	      let willBeAnimated = jQueryt.find('.slideshow__item__wrapper').length > 1;
	      let isAutoplay = jQueryt.attr("autoplay") && willBeAnimated;
	      let isAutoplayHoverPause = jQueryt.attr("autoplayHoverPause") && willBeAnimated;
	      let autoplayTimeoutAttr = jQueryt.attr("autoplayTimeout");
	      if (autoplayTimeoutAttr === '' || Number.isNaN(autoplayTimeoutAttr)) {
	        autoplayTimeoutAttr = 8000;
	      }
	      let smartSpeedAttr = jQueryt.attr("smartSpeed");
	      if (smartSpeedAttr === '' || Number.isNaN(smartSpeedAttr)) {
	        smartSpeedAttr = 200;
	      }
	      jQueryt.owlCarousel({
	        items: 1,
	        margin: 10,
	        loop: willBeAnimated,
	        nav: false,
	        autoplay: isAutoplay,
	        mouseDrag: willBeAnimated,
	        touchDrag: willBeAnimated,
	        autoplayTimeout: autoplayTimeoutAttr,
	        lazyLoad: true,
	        autoplayHoverPause: isAutoplayHoverPause,
	        smartSpeed: smartSpeedAttr,
	      });
	      jQueryt.find('.owl-controls').prepend('<button class="owl-prev">&lt;</button>').append('<button class="owl-next">&gt;</button>');
	      jQueryt.find('.owl-controls .owl-prev').click(function () {
	        jQueryt.trigger('prev.owl.carousel');
	      }).end().find('.owl-controls .owl-next').click(function () {
	        jQueryt.trigger('next.owl.carousel');
	      });
	    });
	    // Owl Carousel
	    jQuery('.owl-carousel-accueil').each(function () {
	      let jQueryt = jQuery(this);
	      let willBeAnimated = jQueryt.find('.carrousel-item').length > 1;
	      jQueryt.owlCarousel({
	        items: 1,
	        margin: 10,
	        loop: willBeAnimated,
	        nav: true,
	        dots: true,
	        autoplay: willBeAnimated,
	        mouseDrag: willBeAnimated,
	        touchDrag: willBeAnimated,
	        autoplayTimeout: 8000,
	        lazyLoad: true,
	        autoplayHoverPause: true
	      });
	      jQueryt.find('.owl-controls').prepend('<button class="owl-prev">&lt;</button>').append('<button class="owl-next">&gt;</button>');
	      jQueryt.find('.owl-controls .owl-prev').click(function () {
	        jQueryt.trigger('prev.owl.carousel');
	      }).end().find('.owl-controls .owl-next').click(function () {
	        jQueryt.trigger('next.owl.carousel');
	      });
	    });
	  });
  
  
  
  
  //Fenetre Dialogue Formation Continue
  if (jQuery('.cours #dialog-confirm').length ) {
	jQuery(".cours input.fc").prop('disabled', false);
	var currentForm;
	var saveOnly = false;

	jQuery( "#dialog-confirm" ).dialog({
		resizable: false,
		autoOpen: false,
		width: "410",
		modal: true,
		closeOnEscape: true,
		buttons: {
			"Non, je refuse": function() {
				jQuery( this ).dialog( "close" );
			},
			"Oui, j'accepte": function() {
				jQuery( this ).dialog( "close" );
				currentForm.submit();
			}
		}
	});
		 
	jQuery( ".fc" ).click(function() {                
		currentForm = jQuery(this).closest( "form" );
		//var intituleReleve = "EEE";
		//jQuery( "#dialog-confirm p" ).first().text(intituleReleve);
		jQuery( "#dialog-confirm" ).dialog( "open" );
		return false;
	});
  }
  
  if (jQuery("#FC-TITRE").length ) {
	  jQuery("#FC-TITRE").val(getParameterByName("fc"));
  }
  
  
  if (jQuery("#URLPAGE403").length ) {
	  jQuery("#URLPAGE403").val(jQuery("#pageDemandee").val());
  }
  
  jQuery("a#afficher_formulaire_contact_403").click(function() {
	    jQuery("#forumlaire_contact_403").toggle();
  });
  
  //Pour afficher uniquement les prochains evenements qui auront lieu dans X (numberOfDays) jours 
  if (jQuery("div[class^='liste_classique_']").length ) {
	var classDiv = jQuery("div[class^='liste_classique_']").attr('class');
	var posUnderScore = classDiv.lastIndexOf("_");
	var posPipe = classDiv.lastIndexOf("|");
	var numberOfDaysStart = parseInt(classDiv.substring(posUnderScore+1));
	var numberOfDaysEnd = parseInt(classDiv.substring(posPipe+1));
		if (jQuery.isNumeric(numberOfDaysStart)==true){
			jQuery("div[class^='liste_classique_'] ul.evenements li").each(function(){ 
				if ( compareDates( jQuery(this).attr("datetime")  , numberOfDaysStart) < 0 ){
					jQuery(this).css("display","none"); 
				} 
				if (jQuery.isNumeric(numberOfDaysEnd)==true){
					if ( compareDates( jQuery(this).attr("datetime")  , numberOfDaysEnd) > 0 ){
						jQuery(this).css("display","none"); 
					} 
				}
			});
		}
	}

  //INCLUDE HTML PERMETTANT D'OURVIR FERMER DES DIV AVEC ANIMATION ACCORDEON
  if (jQuery('.pagelibre [class^=accordion-solo-]').length ) {
		jQuery(".pagelibre [class^=accordion-solo-]").each(function(){ 
			jQuery(this).closest('[class^=paragraphe--]').wrapAll( "<div class='accordion-solo'>" );
			jQuery(this).closest('[class^=paragraphe__contenu--]').wrapAll( "<div class='accordion-container'>" );
			jQuery(this).parent().children('h2:first-child').insertBefore( jQuery(this).parent()  );
			jQuery( ".accordion-solo" ).accordion({
				header: "h2",
				collapsible: true,
				active: false,
				heightStyle:"content"
		  	  });
		});
  }
  
  
  
  //PORTLET RESEAUX SOCIAUX
  if (jQuery('div#rs').length ) {
	  //Repositionnement des vignettes
	  if (jQuery('img.vignette_rs').length ) {
	    jQuery('img.vignette_rs').resizeToParent();
	  }  
	  //Reclassement des posts par ordre chronologique 
	  if ( jQuery('div#rs div.rs_container').length  ) {
	     tinysort('div#rs div.rs_container',{data:'timestamp',order:'desc'});
	     jQuery('div#rs').fadeIn( "slow" );         
	   }
	   //Déplacement de bloc "retweet" si une photo est présent
	  //jQuery('.rs_container.twitter').each(function() { 
	    //   if ( jQuery(this).children().first().hasClass('twitter_media') && jQuery(this).children(':nth-child(2)').hasClass('rs_retweet')  ) {
	    	//   jQuery( jQuery(this).children(':nth-child(2)') ).insertBefore( jQuery(this).children().first() );
	       //} 
	    //});
	
	   //Chargement d'Isotope (affichage façon mosaïque) 
	   var $grid = jQuery('.rs').isotope({
	     itemSelector: '.grid-item',
	     //layoutMode: 'fitRows',
	     masonry: {
		       //columnWidth: 16,
		       gutter: 25,
		       horizontalOrder: true,
	           isFitWidth: true 
	     }
	   });
	   // filter functions
	   var filterFns = {};
	   // bind filter button click
	   jQuery('.rs_filters_button_group').on( 'click', 'button', function() {
	     var filterValue = $( this ).attr('data-filter');
	     // use filterFn if matches value
	     filterValue = filterFns[ filterValue ] || filterValue;
	     $grid.isotope({ filter: filterValue });
	   });
	   // change is-checked class on buttons
	   jQuery('.rs_button_group').each( function( i, buttonGroup ) {
	     var $buttonGroup = jQuery( buttonGroup );
	     $buttonGroup.on( 'click', 'button', function() {
	       $buttonGroup.find('.is-checked').removeClass('is-checked');
	       $( this ).addClass('is-checked');
	     });
	   });
  }  
  
  
});


/*BUTTON  LYON1*/
/*SUPPRESSION D'ESPACE INUTILE*/
 if (jQuery('div > .UL1button').length ) {
 	jQuery("div > .UL1button").each(function(){ 
	    	if ( jQuery(this).children().eq(1).prop("tagName") == "A" ) {
	    		jQuery(this).html(function (i, html) {
	    			return html.replace(/&nbsp;/g, '');
	    		});
	    	}
 	});
   }
	if (jQuery('p > .UL1button').length ) {
		jQuery("p > .UL1button").each(function(){ 
	    	if ( jQuery(this).children().eq(1).prop("tagName") == "A" ) {
	    		jQuery(this).html(function (i, html) {
	    			return html.replace(/&nbsp;/g, '');
	    		});
	    	}
		});
	}



//MODE LECTURE ZEN
jQuery('a.reader').show().click( function() {
	jQuery('#page_deco').removeAttr('style');
	jQuery('body').removeAttr('style');
	jQuery('#page_deco p').removeAttr('style');
	jQuery('#pretitre').css('overflow','hidden');
	if ( jQuery('body').hasClass('readerMode') ) {
		jQuery('#page_deco').fadeOut(0);
		if (jQuery('.article div.photo').length ) {
			jQuery('.article div.photo').css('width','100%');			
			jQuery('.article div.photo img').resizeToParent();
		}
		jQuery('header, #fil-ariane, #accroche, #menu, .container-visuel-rubrique, #page_deco,  #container-plan-site, footer').fadeToggle(1000);

	}else {
		jQuery('header, #fil-ariane, #accroche, #menu, .container-visuel-rubrique, #page_deco, #container-plan-site, footer').fadeToggle(1000);
	}
	jQuery('body').delay(1000).queue(function(){
		jQuery(this).toggleClass('readerMode');
		  if ( jQuery('body').hasClass('readerMode') ) {
				  jQuery('#page_deco').css('font-size','1.07rem');
				  jQuery('#page_deco p').css('line-height','1.7rem');
				  jQuery('#page_deco').css('line-height','1.7rem');
				  jQuery('#page_deco').css('width','100%');
				  jQuery('#page_deco').css('max-width','42rem');
				  if (jQuery('body.article div.photo').length ) {
					jQuery('.fiche.article div.photo').css('width','42rem');			
					jQuery('body.article div.photo img').resizeToParent();
				  }
				  jQuery('#page_deco').fadeIn("slow");
				  jQuery('body').css('background','none');
			  }
		jQuery(this).dequeue();
	});
	if ( jQuery(this).text() == 'MODE LECTURE' || jQuery(this).text() == 'MODE SITE WEB' ) {
		jQuery(this).text(jQuery(this).text() == 'MODE LECTURE' ? 'MODE SITE WEB' : 'MODE LECTURE');
	} else if ( jQuery(this).text() == 'READER MODE' || jQuery(this).text() == 'WEB SITE MODE') {
		jQuery(this).text(jQuery(this).text() == 'READER MODE' ? 'WEB SITE MODE' : 'READER MODE');
	} else if ( jQuery(this).text() == 'MODO LECTURA' || jQuery(this).text() == 'MODO SITIO WEB') {
		jQuery(this).text(jQuery(this).text() == 'MODO LECTURA' ? 'MODO SITIO WEB' : 'MODO LECTURA');
	}
});

//RACCOURCI CLAVIER MODE ZEN + MODE DYSLEXIE + MODE CONTRASTE
var isCtrl = false;
jQuery(document).keydown(function(e){
	if (e.which == 17 || e.keyCode == 17){ 
		isCtrl = true; // si la touche G a été pressée
	}
	//Toutche escape on désactive
	if (e.which == 27 || e.keyCode == 27) { 
		if ( jQuery('body').hasClass('readerMode') ) { 
			jQuery('a.reader').trigger('click');
		}
		if ( jQuery('body').hasClass('dyslexic') ) {
			jQuery("body").toggleClass( "dyslexic" );
			jQuery.cookie( 'dyslexic', jQuery("body").hasClass( "dyslexic" ) , { path: '/' });
		}
		if ( jQuery('body').hasClass('contrast') ) {
			jQuery("body").toggleClass( "contrast" );
			jQuery.cookie( 'contrast', jQuery("body").hasClass( "contrast" ) , { path: '/' });
		}
	}
}).keyup(function(e){
	if (jQuery('input:focus').length > 0 || jQuery('textarea:focus').length > 0 || isCtrl != true)	{ 
		isCtrl = false; // Si on se trouve dans un input, une textarea ou si on n'a pas pressé la touche G, on ne peut pas faire des raccourcis clavier
		return false;
	}
	if (e.keyCode == true)		{
		var key = e.keyCode;
	} else {
		var key = e.which;
	}
	switch (key) {// On regarde la deuxième touche pressée par l'utilisateur
		// Ctrl + Enter
		case 13:
			jQuery('a.reader').trigger('click');
			return false;
		case 112:
			jQuery("body").toggleClass( "dyslexic" );
			jQuery.cookie( 'dyslexic', jQuery("body").hasClass( "dyslexic" ), { expires: 1, path: '/' } );
			return false;
		case 113:
			jQuery("body").toggleClass( "contrast" );
			jQuery.cookie( 'contrast', jQuery("body").hasClass( "contrast" ), { expires: 1, path: '/' } );
			return false;
			break;
	}
	isCtrl = false; // On réinitialise le booléen

});

//CONTRASTE ET DYSLEXIE
if ( jQuery.cookie('dyslexic') == 'true'){
	jQuery("body").addClass( 'dyslexic' );
}

if (jQuery('a.dys').length ) {
	jQuery( "a.dys" ).click(function() {
		//alert("ok");
		jQuery("body").toggleClass( "dyslexic" );
		jQuery.cookie( 'dyslexic', jQuery("body").hasClass( "dyslexic" ), { expires: 7, path: '/' } );
	});	
}

if ( jQuery.cookie('contrast') == 'true'){
	jQuery("body").addClass( 'contrast' );
}	
	if (jQuery('a.contr').length ) {
	jQuery( "a.contr" ).click(function() {
		//alert("ok");
		jQuery("body").toggleClass( "contrast" );
		jQuery.cookie( 'contrast', jQuery("body").hasClass( "contrast" ), { expires: 7, path: '/' } );
	});	
}	

	
	
	
//PARALAX SUR BANDEAU DE RUBRIQUE ET MENU
jQuery(window).scroll(function() {

	
	 //PROTECTION NUMERO DE TELEPHONE PETITES ANNONCES
	 if (jQuery('body.petiteannonce a#lnt').length ) {
			 jQuery('body.petiteannonce a#lnt').attr("href", "tel:"+jQuery('body.petiteannonce a#lnt').attr('data-original').replace(/ /g,'') );
			 jQuery('body.petiteannonce #nt').html( jQuery('body.petiteannonce a#lnt').attr('data-original') );
	 }
	
	
});

function transitionFor(e,p){
	jQuery(e).css('transition',p);
	jQuery(e).css('-webkit-transition',p);
	jQuery(e).css('-o-transition',p);
	jQuery(e).css('-ms-transition',p);
}


